import React from "react";
import clsx from "clsx";
// import { makeStyles } from "@mui/styles";
import { useCallback } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Links from "@mui/material/Link";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { mainListItems, secondaryListItems } from "./components/SideBar.js";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
// import containerTheme from './theme/containerTheme.js'
import { useEffect, useState } from "react";
import LoadingSpinner from "./components/LoadingSpinner";
import "./Spinner.css";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Swal from "sweetalert2";
import DeleteConfirmation from "./components/DeleteConfirmation";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { classNames } from "primereact/utils";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Modal, Button } from "react-bootstrap";
import usePermissions from "./hooks/usePermissions";
import { PERMISSIONS } from "./constants/permissions";
import PermissionTooltip from "./components/PermissionTooltip";
import { MultiSelect } from "primereact/multiselect";
import { Tag } from "primereact/tag";
import { TriStateCheckbox } from "primereact/tristatecheckbox";
import { Paginator } from "primereact/paginator";
import "./table.css";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AADHeader from "./components/AADHeader.js";
// const useStyles = makeStyles(theme => (containerTheme(theme)));

export default function Home() {
  const username = localStorage.getItem("userName");
  const urlSearchParams = new URLSearchParams(window.location.search);
  const slParam = urlSearchParams.get("sl");
  const esg = urlSearchParams.get("esg");
  var myHeaders = new Headers();
  myHeaders.append("username", username);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const [reporthistory, setReportHistory] = React.useState("");
  const [owner, setOwner] = React.useState("");
  const [supplier, setSupplier] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  // const [message, setMessage] = React.useState(false);
  const [startdate, setStartDate] = React.useState("");
  const [enddate, setEndDate] = React.useState("");
  const [sup, setSup] = React.useState("");
  const [own, setOwn] = React.useState("");
  const [electricitycost, setElectricityCost] = React.useState("");
  const [allusers, setAllUsers] = useState([]);
  const { has: hasPermission } = usePermissions();
  const canManageUsers = hasPermission(PERMISSIONS.MANAGE_USERS_ROLES);
  const [roleList, setRoleList] = useState([]);
  const [editUser, setEditUser] = useState(null); // row being edited; null = modal closed
  const [editRole, setEditRole] = useState(null);
  const [editName, setEditName] = useState("");
  const [editDepartment, setEditDepartment] = useState("");
  const [savingRole, setSavingRole] = useState(false);
  const [message, setMessage] = useState("");
  const [electricitysaving, setElectricitySaving] = React.useState("");
  const [electricityunitcost, setElectricityUnitCost] = React.useState("");
  const [active, setActive] = useState("");
  const [inactive, setInactive] = useState("");
  const [page, setPage] = useState(0);
  const [activeCounter, setActiveCounter] = useState();
  const [inactiveCounter, setInActiveCounter] = useState();
  const [tab, setTab] = useState("active"); // which list the table shows
  const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
  const [deactivateEmail, setDeactivateEmail] = useState("");
  const [deleteMessage, setDeleteMessage] = useState("");
  const [inact, setInact] = useState("");
  const [act, setAct] = useState("");
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    roles: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [filters1, setFilters1] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    roles: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [globalFilterValue1, setGlobalFilterValue1] = useState("");
  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <div class="col-md-6 pd-0">
          <button id="active" className={act} onClick={() => toggleTable("active")}>
            <span className="record-count">{activeCounter}</span>
            <span className="record-title">Active</span>
          </button>
          <button id="inactive" className={inact} onClick={() => toggleTable("inactive")}>
            <span className="record-count">{inactiveCounter}</span>{" "}
            <span className="record-title">Inactive </span>{" "}
          </button>
        </div>
        <div class="col-md-6 pd-0 mt-top10 txt-end">
          <span className="p-input-icon-left">
            <img src="assets/img/search.png" className="search-i" />
            <InputText
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
              placeholder="Search"
            />
          </span>
        </div>
      </div>
    );
  };
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-end">
        <div class="col-md-6 pd-0">
          <button id="active" className={act} onClick={() => toggleTable("active")}>
            <span className="record-count">{activeCounter}</span>
            <span className="record-title">Active</span>
          </button>
          <button id="inactive" className={inact} onClick={() => toggleTable("inactive")}>
            <span className="record-count">{inactiveCounter}</span>{" "}
            <span className="record-title">Inactive </span>{" "}
          </button>
        </div>
        <div class="col-md-6 pd-0 mt-top10 txt-end">
          <span className="p-input-icon-left">
            <img src="assets/img/search.png" className="search-i" />
            <InputText
              value={globalFilterValue1}
              onChange={onGlobalFilterChange1}
              placeholder="Search"
            />
          </span>
        </div>
      </div>
    );
  };
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters = { ...filters1 };

    _filters["global"].value = value;

    setFilters1(_filters);
    setGlobalFilterValue1(value);
  };
  const header = renderHeader();
  const header1 = renderHeader1();

  async function fetchRoles() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}roles`);
      const data = await response.json();
      setRoleList(data.data || []);
    } catch (error) {
      console.error(error);
    }
  }

  const openRoleEditor = (rowData) => {
    setEditUser(rowData);
    setEditRole(Array.isArray(rowData.roles) ? rowData.roles[0] : rowData.roles);
    setEditName(rowData.name || "");
    setEditDepartment(rowData.department || "");
  };

  const closeRoleEditor = () => {
    setEditUser(null);
    setEditRole(null);
    setEditName("");
    setEditDepartment("");
  };

  // Absent isActive (old rows / pre-deploy) counts as active.
  const isActiveUser = (u) => u && u.isActive !== false;
  const activeUsers = (allusers || []).filter(isActiveUser);
  const inactiveUsers = (allusers || []).filter((u) => !isActiveUser(u));
  const visibleUsers = tab === "inactive" ? inactiveUsers : activeUsers;

  // Deactivate (soft) or reactivate a user, then refresh.
  // Deactivate confirmation uses the shared DeleteConfirmation modal (same as SL/LE/BU).
  const showDeactivateModal = (email) => {
    setDeactivateEmail(email);
    setDeleteMessage("Are you sure you want to deactivate the user " + email + "?");
    setDisplayConfirmationModal(true);
  };
  const hideConfirmationModal = () => setDisplayConfirmationModal(false);

  async function setUserActive(email, activate) {
    setDisplayConfirmationModal(false);
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}${activate ? "reactivate-user" : "deactivate-user"}`,
        {
          method: "POST",
          headers: { "Content-type": "application/json", username: username },
          body: JSON.stringify({ email }),
        }
      );
      const data = await res.json();
      setLoading(false);
      if (res.status === 200 && data.success) {
        await fetchUsers();
        Swal.fire({ icon: "success", text: data.data || data.message });
      } else {
        // Server rejects last-admin/self/cross-company; surface its reason.
        Swal.fire({ icon: "error", title: "Could not update", text: data.data || data.message || "Please try again." });
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      Swal.fire({ icon: "error", title: "Could not update", text: "Please try again." });
    }
  }

  // True when nothing was actually changed — keeps Update disabled.
  const editUnchanged = () =>
    editUser &&
    editRole === (Array.isArray(editUser.roles) ? editUser.roles[0] : editUser.roles) &&
    editName === (editUser.name || "") &&
    editDepartment === (editUser.department || "");

  async function saveRole() {
    if (!editUser || !editRole) return;
    setSavingRole(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}update-user`,
        {
          method: "POST",
          headers: { "Content-type": "application/json", username: username },
          body: JSON.stringify({
            email: editUser.email,
            name: editName,
            department: editDepartment,
            role: editRole,
          }),
        }
      );
      const data = await response.json();
      setSavingRole(false);
      if (response.status === 200 && data.success) {
        closeRoleEditor();
        await fetchUsers();
        Swal.fire({ icon: "success", title: "Role updated", text: data.data || data.message });
      } else {
        // Server rejects the last-admin demotion and cross-company edits; surface its reason.
        Swal.fire({ icon: "error", title: "Could not update role", text: data.data || data.message || "Please try again." });
      }
    } catch (error) {
      setSavingRole(false);
      console.error(error);
      Swal.fire({ icon: "error", title: "Could not update role", text: "Please try again." });
    }
  }

  async function fetchUsers() {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}all-registered-users`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        setAllUsers(data.data); // Set the retrieved user data to the state
        const act = (data.data || []).filter((u) => u.isActive !== false);
        setActiveCounter(act.length);
        setInActiveCounter((data.data || []).length - act.length);
      } else {
        setMessage("Failed to fetch users");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setMessage("Failed to fetch users");
      console.error(error);
    }
  }

  useEffect(() => {
    fetchUsers();
    fetchRoles();
    setActive("block");
    setInactive("none");
    setInact("inactive-buttonred");
    setAct("active-buttongreen");
  }, []);

  const toggleTable = (name) => {
    setTab(name);
    // Initialize DataTable instance for the selected tab
    if (name === "active") {
      setActive("block");
      setInactive("none");
      setInact("inactive-buttonred");
      setAct("active-buttongreen");
    } else if (name === "inactive") {
      setInact("active-buttonred");
      setAct("inactive-buttongreen");
      setActive("none");
      setInactive("block");
    }
    setPage(0); // Reset page when switching tables
  };

  const CustomDatePickerInput = ({ value, onClick }) => (
    <div className="date-input-container" onClick={onClick}>
      <input type="text" value={value} readOnly placeholder="Start date" className="date-input" />
      <FaCalendarAlt className="calendar-icon" />
    </div>
  );
  const CustomDatePickerInput1 = ({ value, onClick }) => (
    <div className="date-input-container" onClick={onClick}>
      <input type="text" value={value} readOnly placeholder="End date" className="date-input" />
      <FaCalendarAlt className="calendar-icon" />
    </div>
  );
  const renderHeader2 = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading=""/>;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };

  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader2()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div
        id="page-content-wrapper"
        className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}
      >
        <div class="container formpd">
          <div class="flex">
            <div class="col-md-9">
              <div Class="steps__containt-hader">
                <h3 class="title">Users List</h3>
                <div role="presentation">
                  <Breadcrumbs
                    aria-label="breadcrumb"
                    separator={<NavigateNextIcon fontSize="small" />}
                  >
                    <Links underline="hover" color="inherit">
                      Settings
                    </Links>
                    <Typography color="text.primary">User Management</Typography>
                  </Breadcrumbs>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div Class="steps__containt-hader btalignleft">
                <Link to="/adduser" className="add-cta btalignleft">
                  + Add New User
                </Link>
              </div>
            </div>
          </div>
          <div class="container">{message}</div>
          <div class="col-md-12">
            <DataTable
              value={visibleUsers}
              paginator
              rows={10}
              rowsPerPageOptions={[10, 20, 25, 50]}
              tableStyle={{ minWidth: "50rem" }}
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              dataKey="id"
              filters={filters}
              filterDisplay="row"
              globalFilterFields={["name", "email", "roles"]}
              header={header}
              emptyMessage="No data found."
            >
              <Column
                header=""
                body={(rowData) => (
                  <div>
                    <PermissionTooltip
                      disabled={!canManageUsers}
                      reason="Only a Platform Administrator can change user roles"
                    >
                      <EditIcon
                        title="Edit role"
                        onClick={canManageUsers ? () => openRoleEditor(rowData) : undefined}
                        style={{
                          cursor: canManageUsers ? "pointer" : "not-allowed",
                          color: canManageUsers ? "#407775" : "#b0b0b0",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </PermissionTooltip>

                    <PermissionTooltip
                      disabled={!canManageUsers}
                      reason="Only a Platform Administrator can deactivate users"
                    >
                      {isActiveUser(rowData) ? (
                        <img
                          className="action-icon"
                          src="assets/img/deactivate.png"
                          alt="Deactivate"
                          title="Deactivate"
                          onClick={canManageUsers ? () => showDeactivateModal(rowData.email) : undefined}
                          style={{ cursor: canManageUsers ? "pointer" : "not-allowed", opacity: canManageUsers ? 1 : 0.4 }}
                        />
                      ) : (
                        <img
                          className="action-icon"
                          src="assets/img/reactivate.png"
                          alt="Reactivate"
                          title="Reactivate"
                          onClick={canManageUsers ? () => setUserActive(rowData.email, true) : undefined}
                          style={{ cursor: canManageUsers ? "pointer" : "not-allowed", opacity: canManageUsers ? 1 : 0.4 }}
                        />
                      )}
                    </PermissionTooltip>
                  </div>
                )}
                style={{ minWidth: "5rem" , paddingLeft: "30px"  }}
              />

              <Column
                sortable
                field="name"
                header="Name"
                filter
                filterPlaceholder="Filter"
                style={{ minWidth: "5rem" }}
              />
              <Column
                sortable
                header="Email"
                field="email"
                style={{ minWidth: "5rem" }}
                filter
                filterPlaceholder="Filter"
              />
              <Column
                sortable
                header="Roles"
                field="roles"
                style={{ minWidth: "5rem",paddingRight: "30px" }}
                filter
                filterPlaceholder="Filter"
              />
            </DataTable>
          </div>
        </div>
      </div>

      <DeleteConfirmation
        showModal={displayConfirmationModal}
        hideModal={hideConfirmationModal}
        confirmModal={(email) => setUserActive(email, false)}
        deletename={deactivateEmail}
        message={deleteMessage}
      />

      <Modal
        show={!!editUser}
        onHide={closeRoleEditor}
        className="custom-modal-width-config site-modal"
      >
        <Modal.Header>
          <div className="steps__containt-hader edit-form">
            <h3 className="title">Edit User</h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <form className="edit-form">
            <div className="form-row">
              <div className="form-group col-md-6">
                <label className="formlable" htmlFor="inputUserEmail">
                  {" "}
                  Email Address
                </label>
                <input
                  id="inputUserEmail"
                  type="text"
                  value={editUser?.email || ""}
                  className="form-control"
                  readOnly
                  disabled
                />
              </div>
              <div className="form-group col-md-6">
                <label className="formlable" htmlFor="inputUserName">
                  Full Name <span className="mark-form">*</span>
                </label>
                <input
                  id="inputUserName"
                  type="text"
                  value={editName}
                  onChange={(e) => setEditName(e.target.value)}
                  className="form-control"
                  placeholder="Enter full name"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label className="formlable" htmlFor="inputUserDepartment">
                  Department
                </label>
                <input
                  id="inputUserDepartment"
                  type="text"
                  value={editDepartment}
                  onChange={(e) => setEditDepartment(e.target.value)}
                  className="form-control"
                  placeholder="Enter department"
                />
              </div>
              <div className="form-group col-md-6">
                <label className="formlable" htmlFor="inputUserRole">
                  Role <span className="mark-form">*</span>
                </label>
                <Dropdown
                  id="inputUserRole"
                  className="form-control wd-100"
                  value={editRole || null}
                  onChange={(e) => setEditRole(e.value)}
                  options={roleList && roleList.map((r) => ({ label: r, value: r }))}
                  placeholder="Select Role"
                  filter
                  filterPlaceholder="Search role"
                />
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <div className="edit-form modal-buttons">
            <Button
              className="btn btn-primary"
              disabled={
                savingRole ||
                !editRole ||
                !editName.trim() ||
                editUnchanged()
              }
              onClick={saveRole}
            >
              {savingRole ? "Updating..." : "Update"}
            </Button>
            <Button className="btn btn-cancel" onClick={closeRoleEditor} disabled={savingRole}>
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
